import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";
import { withTranslation } from "react-i18next";

const service1 = `${process.env.PUBLIC_URL}/assets/images/gp_images/find-certified-eco-pros-around-you.webp`
const service2 = `${process.env.PUBLIC_URL}/assets/images/gp_images/search-in-other-locations.webp`
const service3 = `${process.env.PUBLIC_URL}/assets/images/gp_images/filter-for-your-preferences.webp`
const service4 = `${process.env.PUBLIC_URL}/assets/images/gp_images/bookmark-your-favorites.webp`
const service5 = `${process.env.PUBLIC_URL}/assets/images/gp_images/discover-local-offers-matching-your-settings.webp`
const service6 = `${process.env.PUBLIC_URL}/assets/images/gp_images/get-announcements-about-pros-crowdfunding-job-opportunities-or-events.webp`
const service7 = `${process.env.PUBLIC_URL}/assets/images/gp_images/rate-pros-and-their-offers.webp`

const MobileFunctionList1 = [
    {
        icon: <img className="service-logo m-0" src={service1} alt="find-certified-eco-pros-around-you"/>,
        title: "Find certified eco-pros around you",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service2} alt="search-in-other-locations"/>,
        title: "Search in other locations",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service3} alt="filter-for-your-preferences"/>,
        title: "Filter for your preferences",
        description: ""
    },
    
    {
        icon: <img className="service-logo m-0" src={service4} alt="bookmark-your-favorites"/>,
        title: "Bookmark your favorites",
        description: ""
    },
        {
        icon: <img className="service-logo m-0" src={service5} alt="discover-local-offers-matching-your-settings"/>,
        title: "Discover local offers matching your settings",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service6} alt="get-announcements-about-pros-crowdfunding-job-opportunities-or-events"/>,
        title: "Get announcements about pros’ crowdfunding, job opportunities or events",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service7} alt="rate-pros-and-their-offers"/>,
        title: "Rate pros and their offers",
        description: ""
    }
]


class MobileFunctionList1Component extends Component {
    render() {
        const { column } = this.props;
        const ServiceContent = MobileFunctionList1.slice(0, this.props.item);
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="row service-main-wrapper">
                    {ServiceContent.map((val, i) => (
                        <div className={`${column}`} key={i}>
                            <div className="service service__style--2 text-left border-2px-solid-E6EAEE">
                                <div className="icon_service" style={{gap: "20px"}}>
                                    <div className="text-right" style={{ width: "calc(100% - 20px)"}}>
                                        <p className="item-title-large-blue">{t(val.title)}</p>
                                        <p className="item-description-large text-gray-small">{val.description}</p>
                                    </div>
                                   {val.icon}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(MobileFunctionList1Component);
